import React from "react";
import styled from "styled-components";
import DeleteText from "components/common/style/navigation/DeleteText";
import { useUnitDelete } from "hooks/citajteo/dl_unit/useUnitDelete";
import { QUERY_KEYS } from "constant/react_query";
import { DlUnit } from "model/dl_unit/DlUnit";
import toast from "react-hot-toast";
import useConfirm from "common/modal/ConfirmDialog";

type UnitDeleteProps = {
  unit: DlUnit;
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

const UnitDelete = ({ unit, onSuccess, onError }: UnitDeleteProps) => {
  const { unitDeleteMutate } = useUnitDelete({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH],
  });
  const confirm = useConfirm();

  const handleDelete = async () => {
    const confirmed = await confirm({
      title: "Brisanje jedinice",
      message: `Da li želite da obrišete jedinicu ${unit.slug}?`,
    });

    if (!confirmed) {
      return;
    }

    unitDeleteMutate(unit.id, {
      onSuccess: () => {
        toast.success("Uspešno brisanje jedinice.");
        onSuccess?.();
      },
      onError: (error) => {
        console.error("Error deleting unit:", error);
        toast.error("Greška prilikom brisanja jedinice.");
        onError?.(error);
      },
    });
  };

  return (
    <DeleteItem>
      <DeleteText onClick={handleDelete}>obriši</DeleteText>
    </DeleteItem>
  );
};

const DeleteItem = styled.div`
  margin-top: 0.5rem;
`;

export default UnitDelete;
